module.exports = __webpack_public_path__ + "img/m1.54a7e029.jpg";